import api from 'src/constants/api'

import useAccount from 'src/hooks/utils/useAccount'
import useMutation from 'src/hooks/utils/useMutation'

const useDeleteApplicationMutation = () => {
  const account = useAccount()

  return useMutation(
    async (appId: string) => {
      const response = await api.delete(`graph/account/${account.id}/application/${appId}`)
      return response.data
    },
    {
      mutationKey: ['deleteApplication'],
      successMessage: 'Application deleted successfully',
      errorMessage: 'Failed to delete application',
      queryKeysToInvalidate: [['applications', account.id]]
    }
  )
}

export default useDeleteApplicationMutation
